import { StyledAlert } from './StyledComponents';

interface WizardAlertProps {
  serverErrorObj: { displayAt: string; displayMessage: string };
  displayAt: string;
}

const WizardAlert = ({ serverErrorObj, displayAt }: WizardAlertProps): JSX.Element | null => {
  return serverErrorObj.displayMessage && serverErrorObj.displayAt === displayAt ? (
    <StyledAlert
      data-testid="WizardAlert"
      appearance="error"
      body={<div dangerouslySetInnerHTML={{ __html: serverErrorObj.displayMessage }} />}
    />
  ) : null;
};

export default WizardAlert;
